import TUIChat from './index.vue';
export default TUIChat;